//
//
//
//
//
//
//
//
//
//
//
//

import TaskStatus from '~/components/TaskStatus.vue';
import TaskInformation from '~/components/TaskInformation.vue';

export default {
  name: 'Task',
  components: { TaskStatus, TaskInformation },
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
};
